<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :label="label"
          style="border-radius: 20px; height: 50px"
          background-color="#ffffff"
          :value="model"
          full-width
          append-icon="fas fa-calendar"
          single-line
          outlined
          dense
          readonly
          v-on="on"
          clearable
          @click:clear="eventClear"
        ></v-text-field>
      </template>
      <v-date-picker :value="model"
                     @change="setModelData"
                     @input="menu = false">
      </v-date-picker>
    </v-menu>
  </div>

</template>

<script>
    export default {
        props :{
          label: {
            type: String,
            default: ""
          },
          model: {
            type: String,
            required: false
          },
          range : {
            type: Boolean,
            required: false
          }
        },
        name: "DatePicker",
        data(){
          return{
            menu: false,
          }
        },
      computed: {

      },
      methods: {
        setModelData(val) {
          this.modal = false;
          this.$emit("update", val);
        },
        eventClear() {
          this.$emit('onClear')
        }
      },
    }
</script>

<style scoped>
</style>
